
namespace RioERP.Masters {
    export class WhatsAppTemplatesColumns {
        static columnsKey = 'Masters.WhatsAppTemplates';
    }
}